export default (context, html) => html`
<slot></slot>
`;
